import React from 'react';
import { Sizes } from '@MerchantConfigurator/constants/styles';

const CustomContainer = ({
  height = 'auto',
  margin = '0',
  padding = `${Sizes['xl']}`,
  width = '1200px',
  children
}) => {
  return (
    <div
      style={{
        height,
        margin,
        padding,
        width
      }}
    >
      {children}
    </div>
  );
};

export default CustomContainer;
